// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// json
import Config from '../../config.json';

// markup
import SettingsEdgeContentMarkup from 'raw-loader!./markup-edge.html';
import SettingsNodeContentMarkup from 'raw-loader!./markup-node.html';
import SettingsMapContentMarkup from 'raw-loader!./markup-map.html';
import SettingsHelpContentMarkup from 'raw-loader!./markup-help.html';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let node = {};
let edge = {};
let map = {};
let i18n = {};
let i18nJson = {};
let fonts = {};
let design = {};
let clientConfig = {};

let currentNodeId = -1;
let currentEdgeId = -1;
let readFormTimeout = undefined;

const maxVisibilityLevelsDefault = 12;
const wysiwygEditorCSS = `${Config.production.cssPath}wysiwyg-editor.css`;

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Settings {

    constructor() {}

    init(globalStore, globalNode, globalEdge, globalMap, globalI18n, globalFonts, globalDesign, globalClientConfig) {
        log('settings init');

        // global objects
        store = globalStore;
        node = globalNode;
        edge = globalEdge;
        map = globalMap;
        i18n = globalI18n;
        i18nJson = i18n.getCurrentJson();
        fonts = globalFonts;
        design = globalDesign;
        clientConfig = globalClientConfig;

        // needed settings stuff
        setEventListener();
    }

    show() {
        show();
    }

    hide() {
        hide();
    }
    
    putNodeDataToSettings(id) {
        putNodeDataToSettings(id);
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------

// EVENTLISTENER
// ---------------------------------------------------------------
function setEventListener() {
    const app = $('app');
    let translatedSettingsContentMarkup = '';

    $(document).on('edgeClickedEvent', (event, currentEdge) => {
        event.stopPropagation();
        currentEdgeId = currentEdge.data('id');
        // update settings html content
        translatedSettingsContentMarkup = translateSettingsEdgeContentMarkup();
        $('settings-content').html(translatedSettingsContentMarkup);
        // disable or hide settings based on client configuration
        applyEdgeClientConfig();
        // update headline and form fields
        putEdgeDataToSettings(currentEdgeId);
    });

    $(document).on('nodeClickedEvent', (event, currentNode) => {
        event.stopPropagation();
        currentNodeId = currentNode.data('id');
        // update settings html content
        translatedSettingsContentMarkup = translateSettingsNodeContentMarkup();
        $('settings-content').html(translatedSettingsContentMarkup);
        // disable or hide settings based on client configuration
        applyNodeClientConfig();
        // update headline and form fields
        putNodeDataToSettings(currentNodeId);
    });
    
    $(document).on('mapSettingsDataSync', (event, diff) => {
        const newMapData = {
            visibilityLevels: diff.visibilityLevels,
            width: diff.measurement.width,
            height: diff.measurement.height,
            bgColorTop: diff.design.bgColorTop,
            bgColorBottom: diff.design.bgColorBottom
        }
        updateMapDataFromStore(newMapData);
    });
    
    // triggered from map.js
    $(document).on('nodeDataForceSaving', event => {
        updateNodeDataFromStore(getContentFromNodeFormFields());
        log('saved node immediately');
    });
    
    $(document).on('templateNodeCreatedSync', (event, designData) => {
        log('---- -- templateNodeCreatedSync:');
        log(designData);
        log('---- -- ----');
        addObjectTemplateFromNodeFormFields(designData);
    });
    
    $(document).on('templateNodeUpdatedSync', (event, designData) => {
        log('---- -- templateNodeUpdatedSync:');
        log(designData);
        log('---- -- ----');
        updateObjectTemplateRemotely(designData);
    });
    
    $(document).on('templateEdgeCreatedSync', (event, designData) => {
        log('---- -- templateNodeCreatedSync:');
        log(designData);
        log('---- -- ----');
        addObjectTemplateFromEdgeFormFields(designData);
    })
    
    $(document).on('templateEdgeUpdatedSync', (event, designData) => {
        log('---- -- templateNodeUpdatedSync:');
        log(designData);
        log('---- -- ----');
        updateObjectTemplateEdgeRemotely(designData);
    })
    
    $(document).on('nodeDataTinyUpdate', (event, diff) => {
        const nodeId = Object.keys(diff)[0],
          nodeData = diff[nodeId],
          nodeDOM = $(`node[data-id=${nodeId}]`);
        log('nodeDataTinyUpdated : ');
        log(diff);
        log(nodeData.content.content);
        $(`#title`).val(nodeData.content.title);
        if (tinyMCE.editors['content']) {
            tinyMCE.editors['content'].setContent(nodeData.content.content)
        }
        if (tinyMCE.editors['links']) {
            tinyMCE.editors['links'].setContent(nodeData.content.links)
        }
        if (tinyMCE.editors['article']) {
            tinyMCE.editors['article'].setContent(nodeData.content.article)
        }
        //TODO update all the others sections
    });

    // toggle settings navigation
    app.on('click', 'settings .headline', (event) => {
        event.stopPropagation();
        const currentElement = $('.selected');
        const elemId = currentElement.data('id');
        const clickedSection = $(event.currentTarget);
        const lockExtent = clickedSection.data('section') === 'content' ? 'content' : 'appearance';
        const lockEvent = {
            userId: null,
            elemType: currentElement ? currentElement[0].localName : 'map',
            elemId: elemId,
            lockExtent: lockExtent
        }
        // prevent action if section is edited
        if (clickedSection.hasClass('edited')) return;
        if (clickedSection.next().hasClass('hide')){
            toggleSiblingsNavigation(clickedSection);
        }
        toggleNavigation(clickedSection);
        // check if clicked element didn't edited by another user
        // and is section opening/closing to trigger event accordingly
        // $(clickedSection).data('section') !== currentElement.siblings('.edited').data('section')
        if(
          !$(clickedSection).hasClass('edited') &&
          !$(clickedSection).next().hasClass('hide')
        ){
            $(document).trigger('sectionEditedOn', [lockEvent])
        } else if (!$(clickedSection).hasClass('edited')) {
            $(document).trigger('sectionEditedOff', [lockEvent])
        }
    });

    // remove all selected elements (nodes, edges)
    app.on('click', 'settings-close', (event) => {
        event.stopPropagation();
        hide();
        removeClassSelected();
        $(document).trigger('settingsClosed');
    });

    // open map settings
    app.on('click', 'map-settings', (event) => {
        event.stopPropagation();
        // prevent open if map settings edited by another user
        if ($('map-settings').hasClass('edited')) return;
        // update settings html content
        translatedSettingsContentMarkup = translateSettingsMapContentMarkup();
        $('settings-content').html(translatedSettingsContentMarkup);

        // disable or hide settings based on client configuration
        applyMapClientConfig();

        // update form fields
        putMapDataToSettings();

        // show settings
        show();

        // remove all selected elements (nodes, edges,...)
        removeClassSelected();

        // clear all drawing states (nodes, edges,...)
        clearDrawingStates();
        
        $(document).trigger('mapSettingsOpened');
    });

    // open map help
    app.on('click', 'map-help', (event) => {
        event.stopPropagation();
        // update settings html content
        translatedSettingsContentMarkup = translateSettingsHelpContentMarkup();
        $('settings-content').html(translatedSettingsContentMarkup);

        // headline
        $('settings').find('settings-headline').text(i18nJson.help.headline);

        // show settings
        show();

        // remove all selected elements (nodes, edges,...)
        removeClassSelected();

        // clear all drawing states (nodes, edges,...)
        clearDrawingStates();
    });
    
    // open map logs
    app.on('click', 'map-logs', (event) => {
        event.stopPropagation();
        // update settings html content
        translatedSettingsContentMarkup = translateSettingsHelpContentMarkup();
        $('settings-content').html(translatedSettingsContentMarkup);
        
        // headline
        $('settings').find('settings-headline').text(i18nJson.help.headline);
        
        // show settings
        show();
        
        // remove all selected elements (nodes, edges,...)
        removeClassSelected();
        
        // clear all drawing states (nodes, edges,...)
        clearDrawingStates();
        $(document).trigger('eventLogRequested')
    });

    // listen on changed form fields
    let updateData = {};

    // node settings
    app.on('change keyup paste', '#settings-node-form > .content > input, #settings-node-form > .content > select, #settings-node-form > .content > textarea', (event) => {
        event.stopPropagation();
        clearTimeout(readFormTimeout);
        readFormTimeout = setTimeout(() => {
            updateData = getContentFromNodeFormFields();
            updateNodeDataFromStore(updateData);
            $('.cp-color-picker').css('display', 'none');
        }, 60);
    });

    app.on('change keyup paste', '#settings-node-form > .content--design > input, #settings-node-form > .content--design > select, #settings-node-form > .content--design > textarea', (event) => {
        const $field = $(event.currentTarget);
        log('Select object template here:');
        log($field);
        log($field.val());
        log(valueOrNull($field.val()));
        if ($field.attr('id') === 'objectTemplate') {
            store.get().nodes[currentNodeId].design.set({
                objectTemplate: valueOrNull($field.val())
            });
            if ($field.val() !== '') {
                // Only if there is no object template selected, we want to reload to
                // the base settings, otherwise, keep the config.
                reloadNodeDesignDataBasedOnTemplate(currentNodeId);
                return;
            }
        }
        // Always update the action buttons after a change.
        const $settingsContainer = $('#settings-node-form');
        updateActionButtons($settingsContainer);

    });

    app.on('click', '#settings-node-form > .content > .utils button', (event) => {
        event.preventDefault();
        const $button = $(event.currentTarget);
        const $designInputs = $button.closest('.utils').siblings('input, select');

        if ($button.is(':disabled')) return;

        const $settingsContainer = $('#settings-node-form');
        const buttonId = $button.attr('id');
        if (buttonId === 'submit-new-template') {
            let designData = createDesignDataForObjectTemplate($designInputs);
            designData.name = $settingsContainer.find('.new-template-form').find('input').val();
            createObjectTemplateFromNodeFormFields($designInputs)
            $(document).trigger('templateNodeCreate', [designData]);
        } else if (buttonId === 'show-new-template-name') {
            $button.toggleClass('active').siblings('.new-template-form').toggleClass('js-hidden');
        } else if (buttonId === 'submit-update-template') {
            log('---- -- submit-update-template');
            log($designInputs);
            let designData = createDesignDataForObjectUpdateTemplate($designInputs);
            $(document).trigger('templateNodeUpdate', [designData]);
            updateObjectTemplateFromNodeFormFields($designInputs);
        } else if (buttonId === 'submit-reset') {
            reloadNodeDesignDataBasedOnTemplate(currentNodeId);
            $designInputs.not('#objectTemplate, .color-picker').trigger('change');
        }
        updateActionButtons($settingsContainer);
    });

    app.on('change', '#settings-node-form #popupType', (event) => {
        setDefaultEditorFont(tinyMCE.editors['content'], $(event.currentTarget).val());
    });

    // node copy
    app.on('click', 'settings-node > .content > copy-button', (event) => {
        event.stopPropagation();
        const currentNode = $('node.selected'),
          currentNodeId = currentNode.data('id');
        $(document).trigger('nodeCopiedEmit', currentNodeId);
        node.copy(currentNodeId);
    });

    // node remove
    app.on('click', 'settings-node > .content > remove-button, settings-edge > .content > remove-button', (event) => {
        event.stopPropagation();
        $(document).trigger('elementRemoveRemote')
        map.removeSelectedNodeOrEdge();
    });

    // edge settings
    app.on('change keyup paste', '#settings-edge-form > .content > input, #settings-edge-form > .content > select, #settings-edge-form > .content > textarea', (event) => {
        event.stopPropagation();
        clearTimeout(readFormTimeout);
        readFormTimeout = setTimeout(() => {
            updateData = getContentFromEdgeFormFields();
            updateEdgeDataFromStore(updateData);
            $('.cp-color-picker').css('display', 'none');
        }, 60);
    });
    app.on('change', '#settings-edge-form > .content--design > input, #settings-edge-form > .content--design > select, #settings-edge-form > .content--design > textarea', (event) => {
        const $field = $(event.currentTarget);
        if ($field.attr('id') === 'objectTemplate') {
            store.get().edges[currentEdgeId].design.set({
                objectTemplate: valueOrNull($field.val())
            });
            if ($field.val() !== '') {
                // Only if there is no object template selected, we want to reload to
                // the base settings, otherwise, keep the config.
                reloadEdgeDesignDataBasedOnTemplate(currentEdgeId);
                return;
            }
        }
        // Always update the action buttons after a change.
        const $settingsContainer = $('#settings-edge-form');
        updateActionButtons($settingsContainer);
    });

    app.on('click', '#settings-edge-form > .content > .utils button', (event) => {
        event.preventDefault();
        const $button = $(event.currentTarget);
        const $designInputs = $button.closest('.utils').siblings('input, select');

        if ($button.is(':disabled')) return;

        const $settingsContainer = $('#settings-edge-form');
        const buttonId = $button.attr('id');
        if (buttonId === 'submit-new-template') {
            let designData = createDesignDataForObjectTemplateEdge($designInputs);
            designData.name = $settingsContainer.find('.new-template-form').find('input').val();
            createObjectTemplateFromEdgeFormFields($designInputs);
            $(document).trigger('templateEdgeCreate', [designData]);
        } else if (buttonId === 'show-new-template-name') {
            $button.toggleClass('active').siblings('.new-template-form').toggleClass('js-hidden');
        } else if (buttonId === 'submit-update-template') {
            let designData = createDesignDataForObjectUpdateEdgeTemplate($designInputs);
            $(document).trigger('templateEdgeUpdate', [designData]);
            updateObjectTemplateFromEdgeFormFields($designInputs);
        } else if (buttonId === 'submit-reset') {
            reloadEdgeDesignDataBasedOnTemplate(currentEdgeId);
            $designInputs.not('#objectTemplate, .color-picker').trigger('change');
        }
        updateActionButtons($settingsContainer);
    });


    // edge remove
    app.on('click', 'settings-edge > .content > remove-button', (event) => {
        event.stopPropagation();
        map.removeSelectedNodeOrEdge();
    });

    // map settings
    app.on('change keyup paste', '#settings-map-form > .content > input, #settings-map-form > .content > select, #settings-map-form > .content > textarea', (event) => {
        event.stopPropagation();
        clearTimeout(readFormTimeout);
        readFormTimeout = setTimeout(() => {
            updateData = getContentFromMapFormFields();
            updateMapDataFromStore(updateData);
            $('.cp-color-picker').css('display', 'none');
        }, 60);
    });
}

// ---------------------------------------------------------------
// MAP
// ---------------------------------------------------------------

// CLIENT CONFIGURATION
// ---------------------------------------------------------------
function applyMapClientConfig() {
    const getSettingsElement = $('settings-map');

    const noCustomDesign = clientConfig.get().hasCustomDesign === false;
    getSettingsElement.find('#bgColorTop').prop('disabled', noCustomDesign);
    getSettingsElement.find('#bgColorBottom').prop('disabled', noCustomDesign);
}

// FORM DATA
// ---------------------------------------------------------------
function putMapDataToSettings() {
    const getSettingsElement = $('settings-map');
    let selectList = '';

    // headline
    $('settings').find('settings-headline').text(i18nJson.map.settings.headline);

    // base
    getSettingsElement.find('#width').val(store.get().map.measurement.width);
    getSettingsElement.find('#height').val(store.get().map.measurement.height);

    selectList = getMapVisibilityLevelsSelectList();
    getSettingsElement.find('#visibilityLevels').html(selectList);

    // design
    getSettingsElement.find('#bgColorTop').val(store.get().map.design.bgColorTop);
    getSettingsElement.find('#bgColorBottom').val(store.get().map.design.bgColorBottom);

    // init color picker
    initColorPicker(getSettingsElement);

    // init wysiwyg editor
    initWysiwygEditor();
}

function getContentFromMapFormFields() {
    return serializeFormToObject($('#settings-map-form'));
}

// UPDATE MAP
// ---------------------------------------------------------------
function updateMapDataFromStore(updateMapData) {
    store.get().map.set({
        visibilityLevels: parseInt(updateMapData.visibilityLevels),
        measurement: {
            width: parseFloat(updateMapData.width),
            height: parseFloat(updateMapData.height)
        },
        design: {
            bgColorTop: updateMapData.bgColorTop,
            bgColorBottom: updateMapData.bgColorBottom
        }
    });

    log('--- settings.js ---');
    log('update all map data from store');
    log(store.get().map);
    log('---------------');

    // trigger event
    $(document).trigger('updateMapDataEvent');
}

function getMapVisibilityLevelsSelectList() {
    let maxVisibilityLevels = clientConfig.get().maxVisibilityLevels;
    if (!maxVisibilityLevels || maxVisibilityLevels < 0) {
        maxVisibilityLevels = maxVisibilityLevelsDefault;
    }

    let selectList = '';
    for(let level = 1; level <= maxVisibilityLevels; level++) {
        selectList += `<option value="${level}" ${(level === store.get().map.visibilityLevels) ? 'selected' : ''}>${level}</option>`;
    }
    return selectList;
}

// UTIL MAP
// ---------------------------------------------------------------
function translateSettingsMapContentMarkup() {
    const translatedSettingsContentMarkup = SettingsMapContentMarkup
    // base
    .replace('[i18nMapSettingsBaseHeadline]', i18nJson.map.settings.base.headline)

    .replace('[i18nMapSettingsBaseWidthLabel]', i18nJson.map.settings.base.width.label)
    .replace('[i18nMapSettingsBaseWidthPlaceholder]', i18nJson.map.settings.base.width.placeholder)

    .replace('[i18nMapSettingsBaseHeightLabel]', i18nJson.map.settings.base.height.label)
    .replace('[i18nMapSettingsBaseHeightPlaceholder]', i18nJson.map.settings.base.height.placeholder)

    .replace('[i18nMapSettingsBaseVisibilityLevelsLabel]', i18nJson.map.settings.base.visibilityLevels.label)

    .replace('[i18nMapSettingsBaseBgColorTopLabel]', i18nJson.map.settings.base.bgColorTop.label)
    .replace('[i18nMapSettingsBaseBgColorTopPlaceholder]', i18nJson.map.settings.base.bgColorTop.placeholder)

    .replace('[i18nMapSettingsBaseBgColorBottomLabel]', i18nJson.map.settings.base.bgColorBottom.label)
    .replace('[i18nMapSettingsBaseBgColorBottomPlaceholder]', i18nJson.map.settings.base.bgColorBottom.placeholder)
    ;

    return translatedSettingsContentMarkup;
}


// ---------------------------------------------------------------
// EDGE
// ---------------------------------------------------------------

// CLIENT CONFIGURATION
// ---------------------------------------------------------------
function applyEdgeClientConfig() {
    const getSettingsElement = $('settings-edge');

    const noObjectTemplates = clientConfig.get().hasObjectTemplates === false;
    const cannotSelectDesignTemplates = clientConfig.get().canSelectObjectTemplates === false;
    getSettingsElement.find('#objectTemplate').prop('disabled', noObjectTemplates && cannotSelectDesignTemplates);

    const noCustomDesign = clientConfig.get().hasCustomDesign === false;
    getSettingsElement.find('#fontFamily').prop('disabled', noCustomDesign);
    getSettingsElement.find('#fontColor').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderStyle').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderWidth').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderColor').prop('disabled', noCustomDesign);
}


// FORM DATA
// ---------------------------------------------------------------
function putEdgeDataToSettings(edgeId) {
    const getSettingsElement = $('settings-edge');
    let selectList = '';

    // headline
    $('settings').find('settings-headline').text(`${i18nJson.edge.settings.headline}: ${edgeId} ✔`);

    // design
    selectList = getEdgeObjectTemplateSelectList(edgeId);
    getSettingsElement.find('#objectTemplate').html(selectList);

    selectList = getEdgeFontFamilySelectList(edgeId);
    getSettingsElement.find('#fontFamily').html(selectList);

    getSettingsElement.find('#fontSize').val(design.forEdge(edgeId, 'fontSize'));
    getSettingsElement.find('#fontColor').val(design.forEdge(edgeId, 'fontColor'));

    selectList = getEdgeBorderStyleSelectList(edgeId);
    getSettingsElement.find('#borderStyle').html(selectList);

    getSettingsElement.find('#borderWidth').val(design.forEdge(edgeId, 'borderWidth'));
    getSettingsElement.find('#borderColor').val(design.forEdge(edgeId, 'borderColor'));

    // content
    getSettingsElement.find('#contentStart').val(store.get().edges[edgeId].content.start);
    getSettingsElement.find('#contentMiddle').val(store.get().edges[edgeId].content.middle);
    getSettingsElement.find('#contentEnd').val(store.get().edges[edgeId].content.end);

    // visibility
    selectList = getEdgeMinLevelSelectList(edgeId);
    getSettingsElement.find('#minLevel').html(selectList);

    selectList = getEdgeMaxLevelSelectList(edgeId);
    getSettingsElement.find('#maxLevel').html(selectList);

    // visibility levels === 1 --> hide visibility settings
    if(store.get().map.visibilityLevels === 1) {
        getSettingsElement.find('.visibility').addClass('hide')
    }

    // init color picker
    initColorPicker(getSettingsElement);

    // init settings actions buttons
    updateActionButtons(getSettingsElement);
}

function reloadEdgeDesignDataBasedOnTemplate(edgeId) {
    const getSettingsElement = $('settings-edge');
    let selectList = '';

    const currentFont = design.baseForEdge(edgeId, 'fontFamily');
    selectList = getEdgeFontFamilySelectList(edgeId, currentFont);
    getSettingsElement.find('#fontFamily').html(selectList);

    getSettingsElement.find('#fontSize').val(design.baseForEdge(edgeId, 'fontSize'));
    getSettingsElement.find('#fontColor').val(design.baseForEdge(edgeId, 'fontColor'));

    const currentBorderStyle = design.baseForEdge(edgeId, 'borderStyle');
    selectList = getEdgeBorderStyleSelectList(edgeId, currentBorderStyle);
    getSettingsElement.find('#borderStyle').html(selectList);

    getSettingsElement.find('#borderWidth').val(design.baseForEdge(edgeId, 'borderWidth'));
    getSettingsElement.find('#borderColor').val(design.baseForEdge(edgeId, 'borderColor'));

    // init color picker
    initColorPicker(getSettingsElement);

    // init settings actions buttons
    updateActionButtons(getSettingsElement);
}

function getEdgeObjectTemplateSelectList(edgeId) {
    const templates = design.templates;
    const edgeDesign = store.get().edges[edgeId].design || {};
    const edgeObjectTemplateI18n = i18nJson.edge.settings.design.objectTemplate;
    let selectList = `<option value="" ${(!edgeDesign.objectTemplate) ? 'selected' : ''}>${edgeObjectTemplateI18n.defaultOptionText}</option>
        <option value="0" ${(edgeDesign.objectTemplate === '0') ? 'selected' : ''}>${edgeObjectTemplateI18n.globalOptionText}</option>`;

    $.each(templates, (key, templ) => {
        if (templ['type'] === 'edge') {
            selectList += `<option value="${templ.id}" ${(edgeDesign.objectTemplate === templ.id.toString()) ? 'selected' : ''}>${templ.name}</option>`;
        }
    });
    return selectList;
}

function getEdgeFontFamilySelectList(edgeId, currentSelection) {
    const allFonts = fonts.get();
    const currentFontFamily = (typeof currentSelection !== 'undefined') ? currentSelection : design.forEdge(edgeId, 'fontFamily');
    let selectList = `<option value="" ${(!currentFontFamily) ? 'selected' : ''}></option>`;

    $.each(allFonts, (key, font) => {
        selectList += `<option value="${font.family}" ${(currentFontFamily === font.family) ? 'selected' : ''}>${font.displayName}</option>`;
    });

    return selectList;
}

function getEdgeBorderStyleSelectList(edgeId, currentSelection) {
    const currentBorderStyle = (typeof currentSelection !== 'undefined') ? currentSelection : design.forEdge(edgeId, 'borderStyle');
    let selectList = `<option value="" ${(!currentBorderStyle) ? 'selected' : ''}>${i18nJson.edge.settings.design.borderStyle.options[0]}</option>`;
    selectList += `<option value="solid" ${(currentBorderStyle === 'solid') ? 'selected' : ''}>${i18nJson.edge.settings.design.borderStyle.options[1]}</option>`;
    selectList += `<option value="dashed" ${(currentBorderStyle === 'dashed') ? 'selected' : ''}>${i18nJson.edge.settings.design.borderStyle.options[2]}</option>`;
    selectList += `<option value="dotted" ${(currentBorderStyle === 'dotted') ? 'selected' : ''}>${i18nJson.edge.settings.design.borderStyle.options[3]}</option>`;
    return selectList;
}

function getEdgeMinLevelSelectList(edgeId) {
    const edge = store.get().edges[edgeId];
    const nodeFromData = store.get().nodes[edge.node.fromId];
    const nodeToData = store.get().nodes[edge.node.toId];
    const minNodeLevel = Math.max(nodeFromData.visibility.minLevel, nodeToData.visibility.minLevel);
    const maxNodeLevel = Math.min(nodeFromData.visibility.maxLevel, nodeToData.visibility.maxLevel);

    let selectList = '';
    for(let level = 1; level <= store.get().map.visibilityLevels; level++) {
        selectList += `<option value="${level}" ${(level === edge.visibility.minLevel) ? 'selected' : ''}
                       ${(level < minNodeLevel || level > maxNodeLevel) ? 'disabled' : ''}>${level}</option>`;
    }
    return selectList;
}

function getEdgeMaxLevelSelectList(edgeId) {
    const edge = store.get().edges[edgeId];
    const nodeFromData = store.get().nodes[edge.node.fromId];
    const nodeToData = store.get().nodes[edge.node.toId];
    const minNodeLevel = Math.max(nodeFromData.visibility.minLevel, nodeToData.visibility.minLevel);
    const maxNodeLevel = Math.min(nodeFromData.visibility.maxLevel, nodeToData.visibility.maxLevel);

    let selectList = '';
    for(let level = 1; level <= store.get().map.visibilityLevels; level++) {
        selectList += `<option value="${level}" ${(level === edge.visibility.maxLevel) ? 'selected' : ''}
                       ${(level < minNodeLevel || level > maxNodeLevel) ? 'disabled' : ''}>${level}</option>`;
    }
    return selectList;
}

function getContentFromEdgeFormFields() {
    return serializeFormToObject($('#settings-edge-form'));
}

function addObjectTemplateFromEdgeFormFields(designData){
    const userId = Object.keys(designData)[0];
    const $templateSelect = $('#settings-edge-form #objectTemplate');
    designData[userId]['type'] = 'edge';
    let newTemplate = design.createTemplate(designData[userId].name, designData[userId]);
    $templateSelect.append($('<option>', {
        value: newTemplate.id,
        text: newTemplate.name,
        selected: true
    }));
    $templateSelect.trigger('change');
}

function createDesignDataForObjectTemplateEdge($formFields) {
    let $templateSelect = $formFields.filter('#objectTemplate');
    // Serialize form input before saving it as a new template
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['type'] = 'edge';
    return designData;
}

function createObjectTemplateFromEdgeFormFields($formFields) {
    const $templateNameForm = $formFields.siblings('.utils').find('.new-template-form');
    const $templateNameInput = $templateNameForm.find('input');
    let $templateSelect = $formFields.filter('#objectTemplate');
    // Serialize form input before saving it as a new template
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['type'] = 'edge';
    let newTemplate = design.createTemplate($templateNameInput.val(), designData);
    // Setting the new template for this edge
    $templateSelect.append($('<option>', {
        value: newTemplate.id,
        text: newTemplate.name,
        selected: true
    }));
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Resetting template name field and action buttons.
    $templateNameInput.val('');
    $templateNameForm.addClass('js-hidden');
    updateActionButtons($formFields.parents('form'));
    // Trigger the node to be updated in the DOM.
    $(document).trigger('updateEdgeDataEvent', [currentEdgeId]);
}

function updateObjectTemplateEdgeRemotely(designData){
    const userId = Object.keys(designData)[0];
    const templateId = designData[userId].templateId;
    let $templateSelect = $('#settings-edge-form').find('#objectTemplate');
    design.updateTemplate(templateId, designData[userId]);
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Get all edges with this template and trigger a DOM update for those.
    let edges = design.getEdgesWithTemplate(templateId);
    edges.forEach(function (edge) {
        $(document).trigger('updateEdgeDataEvent', [edge.id]);
    })
}

function createDesignDataForObjectUpdateEdgeTemplate($formFields){
    let $templateSelect = $formFields.filter('#objectTemplate');
    const templateId = parseInt($templateSelect.val()) || null;
    // Serialize form data for template update
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['templateId'] = parseInt($templateSelect.val()) || null;
    return designData;
}

function updateObjectTemplateFromEdgeFormFields($formFields) {
    let $templateSelect = $formFields.filter('#objectTemplate');
    const templateId = parseInt($templateSelect.val()) || null;
    // Serialize form data for template update
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    design.updateTemplate(templateId, designData);
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Get all edges with this template and trigger a DOM update for those.
    let edges = design.getEdgesWithTemplate(templateId);
    edges.forEach(function (edge) {
        $(document).trigger('updateEdgeDataEvent', [edge.id]);
    })
}

// UPDATE EDGE
// ---------------------------------------------------------------
function updateEdgeDataFromStore(updateEdgeData) {
    const minLevel = parseInt(updateEdgeData.minLevel);
    const maxLevel = parseInt(updateEdgeData.maxLevel);

    if (minLevel <= maxLevel) {
        const oldMinLevel = store.get().edges[currentEdgeId].visibility.minLevel;
        const oldMaxLevel = store.get().edges[currentEdgeId].visibility.maxLevel;

        store.get().edges[currentEdgeId].set({
            design: {
                objectTemplate: valueOrNull(updateEdgeData.objectTemplate),
                fontFamily: preSaveEdgeValue('fontFamily', updateEdgeData.fontFamily),
                fontSize: preSaveEdgeValue('fontSize', updateEdgeData.fontSize),
                fontColor: preSaveEdgeValue('fontColor', updateEdgeData.fontColor),
                borderStyle: preSaveEdgeValue('borderStyle', updateEdgeData.borderStyle),
                borderWidth: preSaveEdgeValue('borderWidth', updateEdgeData.borderWidth),
                borderColor: preSaveEdgeValue('borderColor', updateEdgeData.borderColor)
            },
            content: {
                start: updateEdgeData.contentStart,
                middle: updateEdgeData.contentMiddle,
                end: updateEdgeData.contentEnd
            },
            visibility: {
                minLevel: minLevel,
                maxLevel: maxLevel
            }
        });

        log('--- settings.js ---');
        log('update all edge data from store');
        log(store.get().edges[currentEdgeId]);
        log('---------------');

        // trigger event
        $(document).trigger('updateEdgeDataEvent', [currentEdgeId]);

        // check if map level control should be updated
        if(minLevel !== oldMinLevel || maxLevel !== oldMaxLevel) {
            // update map level control
            $(document).trigger('updateMapLevelControlEvent', ['edge-visibility-level-updated', currentEdgeId]);
        }
    } else {
        alert('Erste Zoomebene darf nicht kleiner sein als die letzte Zoomebene.');
    }
}

// UTIL EDGE
// ---------------------------------------------------------------
function translateSettingsEdgeContentMarkup() {
    const translatedSettingsContentMarkup = SettingsEdgeContentMarkup
    // edge actions
    .replace('[i18nEdgeRemove]', i18nJson.edge.remove)

    // design
    .replace('[i18nEdgeSettingsDesignObjectTemplateLabel]', i18nJson.edge.settings.design.objectTemplate.label)
    .replace('[i18nEdgeSettingsDesignObjectTemplateOverwriteNote]', i18nJson.edge.settings.design.objectTemplate.overwriteNote)

    .replace('[i18nEdgeSettingsDesignHeadline]', i18nJson.edge.settings.design.headline)

    .replace('[i18nEdgeSettingsDesignFontFamilyLabel]', i18nJson.edge.settings.design.fontFamily.label)

    .replace('[i18nEdgeSettingsDesignFontSizeLabel]', i18nJson.edge.settings.design.fontSize.label)
    .replace('[i18nEdgeSettingsDesignFontSizePlaceholder]', i18nJson.edge.settings.design.fontSize.placeholder)

    .replace('[i18nEdgeSettingsDesignFontColorLabel]', i18nJson.edge.settings.design.fontColor.label)
    .replace('[i18nEdgeSettingsDesignFontColorPlaceholder]', i18nJson.edge.settings.design.fontColor.placeholder)

    .replace('[i18nEdgeSettingsDesignBorderStyleLabel]', i18nJson.edge.settings.design.borderStyle.label)

    .replace('[i18nEdgeSettingsDesignBorderWidthLabel]', i18nJson.edge.settings.design.borderWidth.label)
    .replace('[i18nEdgeSettingsDesignBorderWidthPlaceholder]', i18nJson.edge.settings.design.borderWidth.placeholder)

    .replace('[i18nEdgeSettingsDesignBorderColorLabel]', i18nJson.edge.settings.design.borderColor.label)
    .replace('[i18nEdgeSettingsDesignBorderColorPlaceholder]', i18nJson.edge.settings.design.borderColor.placeholder)

    .replace('[i18nEdgeSettingsDesignUtilsNameLabel]', i18nJson.edge.settings.design.utils.name.label)
    .replace('[i18nEdgeSettingsDesignUtilsNamePlaceholder]', i18nJson.edge.settings.design.utils.name.placeholder)

    .replace('[i18nEdgeSettingsDesignUtilsButtonSave]', i18nJson.edge.settings.design.utils.newTemplateButton)
    .replace('[i18nEdgeSettingsDesignUtilsButtonUpdate]', i18nJson.edge.settings.design.utils.updateTemplateButton)
    .replace('[i18nEdgeSettingsDesignUtilsButtonReset]', i18nJson.edge.settings.design.utils.resetButton)

    // content
    .replace('[i18nEdgeSettingsContentHeadline]', i18nJson.edge.settings.content.headline)

    .replace('[i18nEdgeSettingsContentStartLabel]', i18nJson.edge.settings.content.start.label)
    .replace('[i18nEdgeSettingsContentStartPlaceholder]', i18nJson.edge.settings.content.start.placeholder)

    .replace('[i18nEdgeSettingsContentMiddleLabel]', i18nJson.edge.settings.content.middle.label)
    .replace('[i18nEdgeSettingsContentMiddlePlaceholder]', i18nJson.edge.settings.content.middle.placeholder)

    .replace('[i18nEdgeSettingsContentEndLabel]', i18nJson.edge.settings.content.end.label)
    .replace('[i18nEdgeSettingsContentEndPlaceholder]', i18nJson.edge.settings.content.end.placeholder)

    // visibility
    .replace('[i18nEdgeSettingsVisibilityHeadline]', i18nJson.edge.settings.visibility.headline)

    .replace('[i18nEdgeSettingsVisibilityMinLevelLabel]', i18nJson.edge.settings.visibility.minLevel.label)
    .replace('[i18nEdgeSettingsVisibilityMaxLevelLabel]', i18nJson.edge.settings.visibility.maxLevel.label)
    ;

    return translatedSettingsContentMarkup;
}

function preSaveEdgeValue(prop, newVal) {
    const baseValue = design.baseForEdge(currentEdgeId, prop);
    newVal = castTextInput(newVal);
    if (baseValue === null && newVal === '') newVal = null;
    if (newVal === baseValue) return null;
    return newVal;
}


// ---------------------------------------------------------------
// NODE
// ---------------------------------------------------------------

// CLIENT CONFIGURATION
// ---------------------------------------------------------------
function applyNodeClientConfig() {
    const getSettingsElement = $('settings-node');

    const noObjectTemplates = clientConfig.get().hasObjectTemplates === false;
    const cannotSelectDesignTemplates = clientConfig.get().canSelectObjectTemplates === false;
    getSettingsElement.find('#objectTemplate').prop('disabled', noObjectTemplates && cannotSelectDesignTemplates);

    const noCustomDesign = clientConfig.get().hasCustomDesign === false;
    getSettingsElement.find('#icon').prop('disabled', noCustomDesign);
    getSettingsElement.find('#iconOpacity').prop('disabled', noCustomDesign);
    getSettingsElement.find('#bgColor').prop('disabled', noCustomDesign);
    getSettingsElement.find('#fontFamily').prop('disabled', noCustomDesign);
    getSettingsElement.find('#fontColor').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderStyle').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderWidth').prop('disabled', noCustomDesign);
    getSettingsElement.find('#borderColor').prop('disabled', noCustomDesign);
}


// FORM DATA
// ---------------------------------------------------------------
function putNodeDataToSettings(nodeId) {
    const getSettingsElement = $('settings-node');
    let selectList = '';

    // headline
    $('settings').find('settings-headline').text(`${i18nJson.node.settings.headline}: ${nodeId} ✔`);

    // measurement
    getSettingsElement.find('#width').val(design.forNode(nodeId, 'width'));
    getSettingsElement.find('#height').val(design.forNode(nodeId, 'height'));
    getSettingsElement.find('#radius').val(store.get().nodes[nodeId].measurement.radius);

    // design
    selectList = getNodeObjectTemplateSelectList(nodeId);
    getSettingsElement.find('#objectTemplate').html(selectList);

    selectList = getNodeFontFamilySelectList(nodeId);
    getSettingsElement.find('#fontFamily').html(selectList);

    getSettingsElement.find('#fontSize').val(design.forNode(nodeId, 'fontSize'));
    getSettingsElement.find('#fontColor').val(design.forNode(nodeId, 'fontColor'));
    getSettingsElement.find('#bgColor').val(design.forNode(nodeId, 'bgColor'));
    getSettingsElement.find('#borderColor').val(design.forNode(nodeId, 'borderColor'));
    getSettingsElement.find('#borderWidth').val(design.forNode(nodeId, 'borderWidth'));

    selectList = getNodeBorderStyleSelectList(nodeId);
    getSettingsElement.find('#borderStyle').html(selectList);

    selectList = getNodePopupStyleSelectList(nodeId);
    getSettingsElement.find('#popupType').html(selectList);

    selectList = getNodeTitlePositionSelectList(nodeId);
    getSettingsElement.find('#titlePosition').html(selectList);

    // content
    getSettingsElement.find('#icon').val(design.forNode(nodeId, 'icon'));
    getSettingsElement.find('#iconOpacity').val(design.forNode(nodeId, 'iconOpacity'));
    getSettingsElement.find('#title').val(store.get().nodes[nodeId].content.title);
    getSettingsElement.find('#shortContent').val(store.get().nodes[nodeId].content.shortContent);
    getSettingsElement.find('#nodeLinkTo').val(store.get().nodes[nodeId].content.nodeLinkTo);
    getSettingsElement.find('#nodeSearchTerms').val(store.get().nodes[nodeId].content.nodeSearchTerms);
    getSettingsElement.find('#content').val(store.get().nodes[nodeId].content.content);
    getSettingsElement.find('#article').val(store.get().nodes[nodeId].content.article);
    getSettingsElement.find('#links').val(store.get().nodes[nodeId].content.links);
    getSettingsElement.find('#abstract').val(store.get().nodes[nodeId].content.abstract);

    // navigation
    selectList = getNodeNavigationSelectList(nodeId, 'previousId');
    getSettingsElement.find('#previousId').html(selectList);

    selectList = getNodeNavigationSelectList(nodeId, 'nextId');
    getSettingsElement.find('#nextId').html(selectList);

    // visibility
    selectList = getNodeMinLevelSelectList(nodeId);
    getSettingsElement.find('#minLevel').html(selectList);

    selectList = getNodeMaxLevelSelectList(nodeId);
    getSettingsElement.find('#maxLevel').html(selectList);

    // visibility levels === 1 --> hide visibility settings
    if(store.get().map.visibilityLevels === 1) {
        getSettingsElement.find('.visibility').addClass('hide')
    }

    // init color picker
    initColorPicker(getSettingsElement);

    // init wysiwyg editor
    initWysiwygEditor();

    // init settings actions buttons
    updateActionButtons(getSettingsElement);
}

function reloadNodeDesignDataBasedOnTemplate(nodeId) {
    const getSettingsElement = $('settings-node');
    let selectList = '';

    getSettingsElement.find('#width').val(design.baseForNode(nodeId, 'width'));
    getSettingsElement.find('#height').val(design.baseForNode(nodeId, 'height'));

    const currentFont = design.baseForNode(nodeId, 'fontFamily');
    selectList = getNodeFontFamilySelectList(nodeId, currentFont);
    getSettingsElement.find('#fontFamily').html(selectList);

    getSettingsElement.find('#fontSize').val(design.baseForNode(nodeId, 'fontSize'));
    getSettingsElement.find('#fontColor').val(design.baseForNode(nodeId, 'fontColor'));
    getSettingsElement.find('#bgColor').val(design.baseForNode(nodeId, 'bgColor'));
    getSettingsElement.find('#borderColor').val(design.baseForNode(nodeId, 'borderColor'));
    getSettingsElement.find('#borderWidth').val(design.baseForNode(nodeId, 'borderWidth'));

    const currentBorderStyle = design.baseForNode(nodeId, 'borderStyle');
    selectList = getNodeBorderStyleSelectList(nodeId, currentBorderStyle);
    getSettingsElement.find('#borderStyle').html(selectList);

    const currentTitlePosition = design.baseForNode(nodeId, 'titlePosition');
    selectList = getNodeTitlePositionSelectList(nodeId, currentTitlePosition);
    getSettingsElement.find('#titlePosition').html(selectList);

    getSettingsElement.find('#icon').val(design.baseForNode(nodeId, 'icon'));
    getSettingsElement.find('#iconOpacity').val(design.baseForNode(nodeId, 'iconOpacity'));

    // init color picker
    initColorPicker(getSettingsElement);

    // init settings actions buttons
    updateActionButtons(getSettingsElement);
}

function getNodeObjectTemplateSelectList(nodeId) {
    const templates = design.templates;
    const nodeObjectTemplateI18n = i18nJson.node.settings.design.objectTemplate;
    let selectList = `<option value="" ${(!store.get().nodes[nodeId].design.objectTemplate) ? 'selected' : ''}>${nodeObjectTemplateI18n.defaultOptionText}</option>
        <option value="0" ${(store.get().nodes[nodeId].design.objectTemplate === '0') ? 'selected' : ''}>${nodeObjectTemplateI18n.globalOptionText}</option>`;

    $.each(templates, (key, templ) => {
        if (templ['type'] === 'node') {
            selectList += `<option value="${templ.id}" ${(store.get().nodes[nodeId].design.objectTemplate === templ.id.toString()) ? 'selected' : ''}>${templ.name}</option>`;
        }
    });
    return selectList;
}

function getNodeFontFamilySelectList(nodeId, currentSelection) {
    const allFonts = fonts.get();
    const currentFontFamily = (typeof currentSelection !== 'undefined') ? currentSelection : design.forNode(nodeId, 'fontFamily');
    let selectList = `<option value="" ${(!currentFontFamily) ? 'selected' : ''}></option>`;

    $.each(allFonts, (key, font) => {
        selectList += `<option value="${font.family}" ${(currentFontFamily === font.family) ? 'selected' : ''}>${font.displayName}</option>`;
    });

    return selectList;
}

function getNodeMinLevelSelectList(nodeId) {
    let selectList = '';

    for (let level = 1; level <= store.get().map.visibilityLevels; level++) {
        selectList += `<option value="${level}" ${(level === store.get().nodes[nodeId].visibility.minLevel) ? 'selected' : ''}>${level}</option>`;
    }

    return selectList;
}

function getNodeMaxLevelSelectList(nodeId) {
    let selectList = '';

    for (let level = 1; level <= store.get().map.visibilityLevels; level++) {
        selectList += `<option value="${level}" ${(level === store.get().nodes[nodeId].visibility.maxLevel) ? 'selected' : ''}>${level}</option>`;
    }

    return selectList;
}


function getNodeNavigationSelectList(nodeId, type) {
    let selectList = '<option value="-1">–</option>';

    Object.keys(store.get().nodes).forEach((id) => {
        if (id !== nodeId) {
            selectList += `<option value="${id}" ${(store.get().nodes[nodeId].navigation[type] === parseInt(id)) ? 'selected' : ''}>`;
            selectList += (store.get().nodes[id].content.title?.length > 0) ? (`${id} – ${store.get().nodes[id].content.title}`) : id;
            selectList += '</option>';
        }
    });

    return selectList;
}

function getNodeBorderStyleSelectList(nodeId, currentSelection) {
    const currentBorderStyle = (typeof currentSelection !== 'undefined') ? currentSelection : design.forNode(nodeId, 'borderStyle');
    const nodeBorderStyleI18n = i18nJson.node.settings.design.borderStyle;
    let selectList = `<option value="" ${(!currentBorderStyle) ? 'selected' : ''}>${nodeBorderStyleI18n.options[0]}</option>`;
    selectList +=  `<option value="solid" ${(currentBorderStyle === 'solid') ? 'selected' : ''}>${nodeBorderStyleI18n.options[1]}</option>`;
    selectList += `<option value="dashed" ${(currentBorderStyle === 'dashed') ? 'selected' : ''}>${nodeBorderStyleI18n.options[2]}</option>`;
    selectList += `<option value="dotted" ${(currentBorderStyle === 'dotted') ? 'selected' : ''}>${nodeBorderStyleI18n.options[3]}</option>`;
    return selectList;
}

function getNodePopupStyleSelectList(nodeId) {
    const nodePopupStyleI18n = i18nJson.node.settings.content.type;
    let selectList = `<option value="popup-small" ${(store.get().nodes[nodeId].design.popupType === 'popup-small') ? 'selected' : ''}>${nodePopupStyleI18n.options[0]}</option>`;
    selectList += `<option value="popup-medium" ${(store.get().nodes[nodeId].design.popupType === 'popup-medium') ? 'selected' : ''}>${nodePopupStyleI18n.options[1]}</option>`;
    selectList += `<option value="popup" ${(store.get().nodes[nodeId].design.popupType === 'popup') ? 'selected' : ''}>${nodePopupStyleI18n.options[2]}</option>`;
    selectList += `<option value="popup-panel" ${(store.get().nodes[nodeId].design.popupType === 'popup-panel') ? 'selected' : ''}>${nodePopupStyleI18n.options[3]}</option>`;
    selectList += `<option value="popup-panel-large" ${(store.get().nodes[nodeId].design.popupType === 'popup-panel-large') ? 'selected' : ''}>${nodePopupStyleI18n.options[4]}</option>`;
    return selectList;
}

function getNodeTitlePositionSelectList(nodeId, currentSelection) {
    const currentTitlePosition = (typeof currentSelection !== 'undefined') ? currentSelection : design.forNode(nodeId, 'titlePosition');
    const nodeTtitlePositionI18n = i18nJson.node.settings.design.titlePosition;
    let selectList = `<option value="" ${(!currentTitlePosition) ? 'selected' : ''}>${nodeTtitlePositionI18n.options[0]}</option>`;
    selectList += `<option value="top-left" ${(currentTitlePosition === 'top-left') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[1]}</option>`;
    selectList += `<option value="top-center" ${(currentTitlePosition === 'top-center') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[2]}</option>`;
    selectList += `<option value="top-right" ${(currentTitlePosition === 'top-right') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[3]}</option>`;
    selectList += `<option value="left" ${(currentTitlePosition === 'left') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[4]}</option>`;
    selectList += `<option value="center" ${(currentTitlePosition === '' || currentTitlePosition === 'center') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[5]}</option>`;
    selectList += `<option value="right" ${(currentTitlePosition === 'right') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[6]}</option>`;
    selectList += `<option value="bottom-left" ${(currentTitlePosition === 'bottom-left') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[7]}</option>`;
    selectList += `<option value="bottom-center" ${(currentTitlePosition === 'bottom-center') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[8]}</option>`;
    selectList += `<option value="bottom-right" ${(currentTitlePosition === 'bottom-right') ? 'selected' : ''}>${nodeTtitlePositionI18n.options[9]}</option>`;
    return selectList;
}

function getContentFromNodeFormFields() {
    return serializeFormToObject($('#settings-node-form'));
}

function createDesignDataForObjectTemplate($formFields){
    const $templateNameForm = $formFields.siblings('.utils').find('.new-template-form');
    let $templateSelect = $formFields.filter('#objectTemplate');
    // Serialize form input before saving it as a new template
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['height'] = designData['width'];
    designData['type'] = 'node';
    return designData;
}

function createObjectTemplateFromNodeFormFields($formFields) {
    log('');
    log('___ ___ ___');
    log('$formFields are:');
    log($formFields);
    log('___ ___ ___');
    const $templateNameForm = $formFields.siblings('.utils').find('.new-template-form');
    const $templateNameInput = $templateNameForm.find('input');
    let $templateSelect = $formFields.filter('#objectTemplate');
    // Serialize form input before saving it as a new template
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['height'] = designData['width'];
    designData['type'] = 'node';
    let newTemplate = design.createTemplate($templateNameInput.val(), designData);
    log('newTemplate:');
    log(newTemplate);
    log($templateSelect);
    // Setting the new template for this node
    $templateSelect.append($('<option>', {
        value: newTemplate.id,
        text: newTemplate.name,
        selected: true
    }));
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Resetting template name field and action buttons.
    $templateNameInput.val('');
    $templateNameForm.addClass('js-hidden');
    updateActionButtons($formFields.parents('form'));
    // Trigger the node to be updated in the DOM.
    $(document).trigger('updateNodeDataEvent', [currentNodeId]);
}

function addObjectTemplateFromNodeFormFields(designData) {
    log('ADD Object Template From Node Form Fields');
    log(designData);
    const userId = Object.keys(designData)[0];
    const $templateSelectLocalDOM = $('#settings-node-form #objectTemplate');
    let newTemplate = design.createTemplate(designData[userId].name, designData[userId]);
    log('newTemplate:');
    log(newTemplate);
    // Setting the new template for this node
    $templateSelectLocalDOM.append($('<option>', {
        value: newTemplate.id,
        text: newTemplate.name,
        selected: false
    }));
    // Trigger change to the field so that data is going to be saved.
    $templateSelectLocalDOM.trigger('change');
    // Resetting template name field and action buttons.
    /*$templateNameInput.val('');
    $templateNameForm.addClass('js-hidden');*/
    // updateActionButtons($formFields.parents('form'));
    // Trigger the node to be updated in the DOM.
    // $(document).trigger('updateNodeDataEvent', [currentNodeId]);
}

function createDesignDataForObjectUpdateTemplate($formFields){
    let $templateSelect = $formFields.filter('#objectTemplate');
    const templateId = parseInt($templateSelect.val()) || null;
    // Serialize form data for template update
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['height'] = designData['width'];
    designData['templateId'] = parseInt($templateSelect.val()) || null;
    return designData;
}

function updateObjectTemplateRemotely(designData){
    const userId = Object.keys(designData)[0];
    const templateId = designData[userId].templateId;
    let $templateSelect = $('#settings-node-form').find('#objectTemplate');
    
    design.updateTemplate(templateId, designData[userId]);
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Get all nodes with this template and trigger a DOM update for those.
    let nodes = design.getNodesWithTemplate(templateId);
    log('updateObjectTemplateFromNodeFormFields');
    nodes.forEach(function (node) {
        log(node.id);
        $(document).trigger('updateNodeDataEvent', [node.id]);
    })
}

function updateObjectTemplateFromNodeFormFields($formFields) {
    let $templateSelect = $formFields.filter('#objectTemplate');
    const templateId = parseInt($templateSelect.val()) || null;
    // Serialize form data for template update
    let designData = serializeAndCastFormData($formFields.not($templateSelect));
    designData['height'] = designData['width'];
    design.updateTemplate(templateId, designData);
    // Trigger change to the field so that data is going to be saved.
    $templateSelect.trigger('change');
    // Get all nodes with this template and trigger a DOM update for those.
    let nodes = design.getNodesWithTemplate(templateId);
    log('updateObjectTemplateFromNodeFormFields');
    nodes.forEach(function (node) {
        log(node.id);
        $(document).trigger('updateNodeDataEvent', [node.id]);
    })
}

// UPDATE NODE
// ---------------------------------------------------------------
function updateNodeDataFromStore(updateNodeData) {
    const minLevel = parseInt(updateNodeData.minLevel);
    const maxLevel = parseInt(updateNodeData.maxLevel);
    if (minLevel <= maxLevel) {
        const oldMinLevel = store.get().nodes[currentNodeId].visibility.minLevel;
        const oldMaxLevel = store.get().nodes[currentNodeId].visibility.maxLevel;

        store.get().nodes[currentNodeId].set({
            measurement: {
                width: preSaveNodeValue('width', updateNodeData.width),
                // height: updateNodeData.height,
                height: preSaveNodeValue('height', updateNodeData.width),
                // radius: updateNodeData.radius
                radius: 50
            },
            visibility: {
                minLevel: minLevel,
                maxLevel: maxLevel
            },
            design: {
                objectTemplate: valueOrNull(updateNodeData.objectTemplate),
                fontFamily: preSaveNodeValue('fontFamily', updateNodeData.fontFamily),
                fontSize: preSaveNodeValue('fontSize', updateNodeData.fontSize),
                fontColor: preSaveNodeValue('fontColor', updateNodeData.fontColor),
                bgColor: preSaveNodeValue('bgColor', updateNodeData.bgColor),
                borderStyle: preSaveNodeValue('borderStyle', updateNodeData.borderStyle),
                borderWidth: preSaveNodeValue('borderWidth', updateNodeData.borderWidth),
                borderColor: preSaveNodeValue('borderColor', updateNodeData.borderColor),
                getOwnPropertyNames: '0',// todo hack to remove
                popupType: updateNodeData.popupType,
                titlePosition: preSaveNodeValue('titlePosition', updateNodeData.titlePosition),
                iconOpacity: preSaveNodeValue('iconOpacity', updateNodeData.iconOpacity)
            },
            content: {
                icon: preSaveNodeValue('icon', updateNodeData.icon),
                title: updateNodeData.title,
                // shortContent: updateNodeData.shortContent,
                shortContent: '',
                nodeLinkTo: updateNodeData.nodeLinkTo,
                nodeSearchTerms: updateNodeData.nodeSearchTerms,
                content: updateNodeData.content,
                article: updateNodeData.article,
                links: updateNodeData.links,
                abstract: updateNodeData.abstract
            },
            navigation: {
                previousId: parseInt(updateNodeData.previousId),
                nextId: parseInt(updateNodeData.nextId)
            }
        });

        log('--- settings.js ---');
        log('update all node data from store');
        log(store.get().nodes[currentNodeId]);
        log('---------------');

        // trigger event
        $(document).trigger('updateNodeDataEvent', [currentNodeId]);

        // check if map level control should be updated
        if(minLevel !== oldMinLevel || maxLevel !== oldMaxLevel) {
            // update map level control
            $(document).trigger('updateMapLevelControlEvent', ['node-visibility-level-updated', currentNodeId]);
        }

    } else {
        alert('Erste Zoomebene darf nicht kleiner sein als die letzte Zoomebene.');
    }
}

// UTIL NODE
// ---------------------------------------------------------------
function translateSettingsNodeContentMarkup() {
    const translatedSettingsContentMarkup = SettingsNodeContentMarkup
    // node actions
    .replace('[i18nNodeCopy]', i18nJson.node.copy)
    .replace('[i18nNodeRemove]', i18nJson.node.remove)

    .replace('[i18nNodeSettingsContentTitleLabel]', i18nJson.node.settings.name.label)
    .replace('[i18nNodeSettingsContentTitlePlaceholder]', i18nJson.node.settings.name.placeholder)

    // node content
    .replace('[i18nNodeSettingsContentHeadline]', i18nJson.node.settings.content.headline)

    .replace('[i18nNodeSettingsContentNodeLinkToLabel]', i18nJson.node.settings.content.nodeLinkTo.label)
    .replace('[i18nNodeSettingsContentNodeLinkToPlaceholder]', i18nJson.node.settings.content.nodeLinkTo.placeholder)

    .replace('[i18nNodeSettingsPopupTypeLabel]', i18nJson.node.settings.content.type.label)

    .replace('[i18nNodeSettingsPopupContentLabel]', i18nJson.node.settings.content.content.label)
    .replace('[i18nNodeSettingsPopupContentPlaceholder]', i18nJson.node.settings.content.content.placeholder)

    .replace('[i18nNodeSettingsPopupMarginalInfo1Label]', i18nJson.node.settings.content.marginal1.label)
    .replace('[i18nNodeSettingsPopupMarginalInfo1Placeholder]', i18nJson.node.settings.content.marginal1.placeholder)

    .replace('[i18nNodeSettingsPopupMarginalInfo2Label]', i18nJson.node.settings.content.marginal2.label)
    .replace('[i18nNodeSettingsPopupMarginalInfo2Placeholder]', i18nJson.node.settings.content.marginal2.placeholder)

    .replace('[i18nNodeSettingsPopupAbstractLabel]', i18nJson.node.settings.content.abstract.label)

    .replace('[i18nNodeSettingsContentNodeSearchTermsLabel]', i18nJson.node.settings.content.nodeSearchTerms.label)

    // node design
    .replace('[i18nNodeSettingsDesignHeadline]', i18nJson.node.settings.design.headline)

    .replace('[i18nNodeSettingsDesignObjectTemplateLabel]', i18nJson.node.settings.design.objectTemplate.label)
    .replace('[i18nNodeSettingsDesignObjectTemplateOverwriteNote]', i18nJson.node.settings.design.objectTemplate.overwriteNote)

    .replace('[i18nNodeSettingsContentIconLabel]', i18nJson.node.settings.design.icon.label)
    .replace('[i18nNodeSettingsContentIconPlaceholder]', i18nJson.node.settings.design.icon.placeholder)

    .replace('[i18nNodeSettingsDesignIconOpacityLabel]', i18nJson.node.settings.design.iconOpacity.label)

    .replace('[i18nNodeSettingsContentTitlePositionLabel]', i18nJson.node.settings.design.titlePosition.label)

    .replace('[i18nNodeSettingsDesignWidthLabel]', i18nJson.node.settings.design.width.label)
    .replace('[i18nNodeSettingsDesignWidthPlaceholder]', i18nJson.node.settings.design.width.placeholder)

    .replace('[i18nNodeSettingsDesignBgColorLabel]', i18nJson.node.settings.design.bgColor.label)
    .replace('[i18nNodeSettingsDesignBgColorPlaceholder]', i18nJson.node.settings.design.bgColor.placeholder)

    .replace('[i18nNodeSettingsDesignFontFamilyLabel]', i18nJson.node.settings.design.fontFamily.label)

    .replace('[i18nNodeSettingsDesignFontSizeLabel]', i18nJson.node.settings.design.fontSize.label)
    .replace('[i18nNodeSettingsDesignFontSizePlaceholder]', i18nJson.node.settings.design.fontSize.placeholder)

    .replace('[i18nNodeSettingsDesignFontColorLabel]', i18nJson.node.settings.design.fontColor.label)
    .replace('[i18nNodeSettingsDesignFontColorPlaceholder]', i18nJson.node.settings.design.fontColor.placeholder)

    .replace('[i18nNodeSettingsDesignBorderStyleLabel]', i18nJson.node.settings.design.borderStyle.label)

    .replace('[i18nNodeSettingsDesignBorderWidthLabel]', i18nJson.node.settings.design.borderWidth.label)
    .replace('[i18nNodeSettingsDesignBorderWidthPlaceholder]', i18nJson.node.settings.design.borderWidth.placeholder)

    .replace('[i18nNodeSettingsDesignBorderColorLabel]', i18nJson.node.settings.design.borderColor.label)
    .replace('[i18nNodeSettingsDesignBorderColorPlaceholder]', i18nJson.node.settings.design.borderColor.placeholder)

    .replace('[i18nNodeSettingsDesignUtilsNameLabel]', i18nJson.node.settings.design.utils.name.label)
    .replace('[i18nNodeSettingsDesignUtilsNamePlaceholder]', i18nJson.node.settings.design.utils.name.placeholder)

    .replace('[i18nNodeSettingsDesignUtilsButtonSave]', i18nJson.node.settings.design.utils.newTemplateButton)
    .replace('[i18nNodeSettingsDesignUtilsButtonUpdate]', i18nJson.node.settings.design.utils.updateTemplateButton)
    .replace('[i18nNodeSettingsDesignUtilsButtonReset]', i18nJson.node.settings.design.utils.resetButton)

    // node visibility
    .replace('[i18nNodeSettingsVisibilityHeadline]', i18nJson.node.settings.visibility.headline)

    .replace('[i18nNodeSettingsVisibilityMinLevelLabel]', i18nJson.node.settings.visibility.minLevel.label)
    .replace('[i18nNodeSettingsVisibilityMaxLevelLabel]', i18nJson.node.settings.visibility.maxLevel.label)

    // node navigation
    .replace('[i18nNodeSettingsNavigationHeadline]', i18nJson.node.settings.navigation.headline)

    .replace('[i18nNodeSettingsNavigationPreviousIdLabel]', i18nJson.node.settings.navigation.previousId.label)
    .replace('[i18nNodeSettingsNavigationNextIdLabel]', i18nJson.node.settings.navigation.nextId.label)
    ;

    return translatedSettingsContentMarkup;
}

function preSaveNodeValue(prop, newVal) {
    const baseValue = design.baseForNode(currentNodeId, prop);
    newVal = castTextInput(newVal);
    // If there is no baseValue, don't override it with an empty string.
    // If there is a baseValue, override it with the empty string.
    if (baseValue === null && newVal === '') newVal = null;
    if (newVal === baseValue) return null;
    return newVal;
}

// ---------------------------------------------------------------
// HELP UTIL
// ---------------------------------------------------------------
function translateSettingsHelpContentMarkup() {
    let translatedSettingsContentMarkup = '';

    // node add
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(SettingsHelpContentMarkup, '[i18nHelpSettingsNodeAddHeadline]', '[i18nHelpSettingsNodeAddSteps]', i18nJson.help.node.add.headline, i18nJson.help.node.add.steps);
    // node copy
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsNodeCopyHeadline]', '[i18nHelpSettingsNodeCopySteps]', i18nJson.help.node.copy.headline, i18nJson.help.node.copy.steps);
    // node remove
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsNodeRemoveHeadline]', '[i18nHelpSettingsNodeRemoveSteps]', i18nJson.help.node.remove.headline, i18nJson.help.node.remove.steps);
    // connect two nodes
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsConnectTwoNodesHeadline]', '[i18nHelpSettingsConnectTwoNodesSteps]', i18nJson.help.connectTwoNodes.headline, i18nJson.help.connectTwoNodes.steps);
    // remove connection between two nodes
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsRemoveConnectionBetweenTwoNodesHeadline]', '[i18nHelpSettingsRemoveConnectionBetweenTwoNodesSteps]', i18nJson.help.removeConnectionBetweenTwoNodes.headline, i18nJson.help.removeConnectionBetweenTwoNodes.steps);
    // set color
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsSetColorHeadline]', '[i18nHelpSettingsSetColorSteps]', i18nJson.help.setColor.headline, i18nJson.help.setColor.steps);
    // visibility level next
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsVisibilityLevelNextHeadline]', '[i18nHelpSettingsVisibilityLevelNextSteps]', i18nJson.help.visibilityLevel.next.headline, i18nJson.help.visibilityLevel.next.steps);
    // visibility level previous
    translatedSettingsContentMarkup = translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, '[i18nHelpSettingsVisibilityLevelPreviousHeadline]', '[i18nHelpSettingsVisibilityLevelPreviousSteps]', i18nJson.help.visibilityLevel.previous.headline, i18nJson.help.visibilityLevel.previous.steps);

    return translatedSettingsContentMarkup;
}

function translaterSettingsHelpContentMarkup(translatedSettingsContentMarkup, findHeadline, findSteps, i18nJsonHeadline, i18nJsonSteps) {
    translatedSettingsContentMarkup = translatedSettingsContentMarkup.replace(findHeadline, i18nJsonHeadline);
    let steps = '';

    for (const value of i18nJsonSteps) { steps += (i18nJsonSteps.length > 1) ? `<li>${value}</li>` : value;}
    translatedSettingsContentMarkup = translatedSettingsContentMarkup.replace(findSteps, steps);

    return translatedSettingsContentMarkup;
}

function valueOrNull(val) {
    if (typeof val === 'number' && Number(val) === val) {
        // For numbers, 0 is a valid number and should be used.
        return val;
    } else if (typeof val === 'string') {
        // For strings, an empty string is equal to null.
        val = val.trim();
    }
    return val || null;
}

function castTextInput(val) {
    const newVal = (typeof val === 'string') ? val.trim() : val;
    // No need to convert empty strings
    if (newVal === '') return newVal;
    // Convert numbers
    if (!isNaN(newVal)) return Number(newVal);
    return newVal;
}

// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function serializeFormToObject(form) {
    const serializedObject = {};
    const formData = form.serializeArray();

    $.each(formData, (key, item) => {

        if(serializedObject[item.name]) {

            if(!serializedObject[item.name].push) {
               serializedObject[item.name] = [serializedObject[item.name]];
            }

            serializedObject[item.name].push(item.value || '');
        } else {
            serializedObject[item.name] = item.value || '';
        }
    });

   return serializedObject;
}

function serializeAndCastFormData(elements) {
    return $.makeArray(elements).reduce((acc, item) => {
        if (item.tagName === 'INPUT' && item.type === 'number') {
            let val = item.valueAsNumber;
            acc[item.id] = (isNaN(val)) ? null : val ;
        } else if (item.tagName === 'SELECT') {
            let val = $(item).val();
            acc[item.id] = parseInt(val) || val || null
        } else {
            acc[item.id] = $(item).val() || null;
        }
        return acc;
    }, {});
}


function toggleNavigation(clickedElement) {
    clickedElement.next().toggleClass('hide');
}

function toggleSiblingsNavigation(clickedElement) {
    clickedElement.siblings('.content').addClass('hide');
}

function show() {
    $('settings').removeClass('hide');
}

function hide() {
    $('settings').addClass('hide');
}

function removeClassSelected() {
    edge.removeClassSelected();
    node.removeClassSelected();
    node.removeClassDrawSelected();
}

function clearDrawingStates() {
    node.clearDrawingStates();
}

let triggerColorChangeTimout = undefined;

function initColorPicker(settingsElement) {
    settingsElement.find('.color-picker').colorPicker({
        dark: '#404040',
        light: '#FFFFFF',
        color: 'rgba(0,0,0,1)',
        renderCallback: function($elm, toggled) {
            if ((toggled === true) && ($elm.val().trim() === '')) {
                // opening picker
                this.color.setColor('rgb(0, 0, 0)', 'rgb', 1);
                this.render();
            } else if (toggled === false) {
                // closing picker
                $elm.trigger('change');
            } else if (!toggled) {
                // changing color
                clearTimeout(triggerColorChangeTimout);
                triggerColorChangeTimout = setTimeout(() => {
                    $elm.trigger('change');
                }, 500)
            }
        },
    });
}

let initWysiwygEditorTimeout = undefined;
let updateWysiwygTextareaTimeout = undefined;

function customURLConverter(url, node, on_save, name) {
  // Note: duplicates in derkontext.js and kontextlab.js
  var l = document.createElement('a');
  // Set link and remove relative path part before the browser converts
  // the relative part.
  l.href = url.replace(/^(\.\.\/)+/, '/');
  if (window.location.host !== l.host) {
      return url;
  }
  // Replace duplicates for /client
  var path = l.pathname.replace(/^(\/client){2,}/, '/client');
  // Create an absolute path without hostname
  return path + l.search + l.hash;
}

function setDefaultEditorFont(ed, forPopupType) {
    const fontFamily =  design.forPopup('fontFamily');
    const fontSize = design.forPopup('fontSize');
    const fontColor = design.forPopup('fontColor');
    const popupTypeMap = {
        'popup': 'detached',
        'popup-medium': 'detached_medium',
        'popup-small': 'detached_small',
        'popup-panel': 'small',
        'popup-panel-large': 'large'
    };
    const currentNode = store.get().nodes[currentNodeId];
    const popupType = forPopupType || (currentNode) ? currentNode.design.popupType : 'popup-panel';
    const popupDesignInfoKey = popupTypeMap[popupType] || 'small';
    const popupDesignInfo = store.get().design.popups[popupDesignInfoKey] || {};
    const marginalDesignInfo = store.get().design.popups.marginal || {};

    switch(ed.id) {
        case 'content':
            ed.getBody().style.fontFamily = popupDesignInfo.fontFamily
              || store.get().map.fonts.popUpContent
              || fontFamily;
            ed.getBody().style.fontSize = `${popupDesignInfo.fontSize || fontSize}px`;
            ed.getBody().style.color = popupDesignInfo.fontColor || fontColor;
            break;
        case 'article':
            ed.getBody().style.fontFamily = marginalDesignInfo.fontFamily
              || store.get().map.fonts.articleContent
              || fontFamily;
            ed.getBody().style.fontSize = `${marginalDesignInfo.fontSize || fontSize}px`;
            ed.getBody().style.color = marginalDesignInfo.fontColor || fontColor;
            break;
        case 'links':
            ed.getBody().style.fontFamily = marginalDesignInfo.fontFamily
              || store.get().map.fonts.linkContent
              || fontFamily;
            ed.getBody().style.fontSize = `${marginalDesignInfo.fontSize || fontSize}px`;
            ed.getBody().style.color = marginalDesignInfo.fontColor || fontColor;
            break;
    }
}

function initWysiwygEditor() {
    const allFonts = fonts.get();
    let fontsList = '';

    // prepare fonts list for tinymce init
    // > select list
    $.each(allFonts, (key, font) => {
        fontsList += `${font.displayName}=${font.family};`;
    });

    // prepare fonts source for tinymce init
    // > import fonts into iframe, otherwise visual font changes do not appear
    const uniqueFontSources = new Set(allFonts.map(font => font.source));
    let fontsSource = '';

    uniqueFontSources.forEach(source => {
        fontsSource += source.replace(/,/g, '%2C') + ',';
    });

    // remove last ,
    fontsSource = fontsSource.substring(0, fontsSource.length - 1);

    // artificial timeout > better ux
    clearTimeout(initWysiwygEditorTimeout);
    initWysiwygEditorTimeout = setTimeout(() => {

        // prevent tinymce instances accumulation
        // eslint-disable-next-line
        if(tinymce.editors.length > 0) { tinymce.remove(); }

        // eslint-disable-next-line
        tinymce.init({
            language: i18n.getLang(),
            statusbar: false,
            height: 180,
            content_css: `${wysiwygEditorCSS},${fontsSource}`,
            font_formats: fontsList,
            extended_valid_elements: 'span[*],script[src|async|defer|type|charset]',
            paste_retain_style_properties: 'font-size',
            plugins: [
                'autolink code fullscreen hr image lists link media noneditable paste preview kontextlab-accordion'
            ],
            selector:'textarea:not(.no-tmce)',
            toolbar: 'fontselect | fontsizeselect | forecolor backcolor | numlist bullist accordion | link',
            urlconverter_callback: customURLConverter,
            menu: {
                    edit: {
                        title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'
                    },
                    insert: {
                        title: 'Insert', items: 'link image media | hr | accordion'
                    },
                    view: {
                        title: 'View', items: 'code preview fullscreen'
                    },
                    format: {
                        title: 'Format', items: 'bold italic underline strikethrough superscript subscript | align | removeformat'
                    }
            },
            fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px',
            setup: (ed) => {
                // set individual body font family tinymce
                // > used for global font changes > based on map options
                ed.on('init', () => {
                    setDefaultEditorFont(ed);
                });

                let currentUsedTextarea = '';

                // detect keyup or content changes
                ed.on('keyup change', () => {
                    clearTimeout(updateWysiwygTextareaTimeout);
                    updateWysiwygTextareaTimeout = setTimeout(() => {
                        // use save mechanism from hidden textarea
                        currentUsedTextarea = $(`textarea#${ed.id}`);
                        currentUsedTextarea.val(ed.getContent()); // transfer tinymce content to hidden textarea
                        currentUsedTextarea.trigger('change');
                    }, 50); // todo timeout were decreased x10
                });
            }
        });
    }, 100);
}

function updateActionButtons($container) {
    const $formSection = $container.find('.content--design');
    const $form = $formSection.parents('form');
    const $formFields = $formSection.children('input, select, textareas');
    const $objectTemplateInput = $formFields.filter('#objectTemplate');
    const $actionBtns = $formFields.siblings('.utils').children('button');
    let valuesEntered = false;
    let valSanitizer;

    if ($form.attr('id') === 'settings-node-form') {
        valSanitizer = preSaveNodeValue;
    } else if ($form.attr('id') === 'settings-edge-form') {
        valSanitizer = preSaveEdgeValue;
    } else {
        throw 'Unknown form ID.';
    }

    $formFields.not($objectTemplateInput).each(function () {
        const $field = $(this);
        const newValue = valSanitizer($field.attr('name'), $field.val());
        if (newValue != null) valuesEntered = true;
    });

    const hasObjectTemplates = clientConfig.get().hasObjectTemplates !== false;
    if (valuesEntered && hasObjectTemplates) {
        $actionBtns.prop('disabled', false);
        if (!$objectTemplateInput.val()) {
            $actionBtns.filter('#submit-reset, #submit-update-template').prop('disabled', true);
            $objectTemplateInput.removeClass('js-hasOverwrites').prev().removeClass('js-hasOverwrites');
        } else if ($objectTemplateInput.val() === '0') {
            $actionBtns.filter('#submit-update-template').prop('disabled', true);
            $objectTemplateInput.addClass('js-hasOverwrites').prev().addClass('js-hasOverwrites');
        } else {
            $objectTemplateInput.addClass('js-hasOverwrites').prev().addClass('js-hasOverwrites');
        }
    } else {
        $actionBtns.prop('disabled', true).removeClass('active');
        $objectTemplateInput.removeClass('js-hasOverwrites').prev().removeClass('js-hasOverwrites');
    }
}
